/* eslint-disable react/jsx-indent-props */
/* eslint-disable indent */
/* eslint-disable linebreak-style */
import "date-fns";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
//import { getMessage } from "src/utils/dictionaryUtils";
import {
  DatePicker,
  StaticDatePicker,
  DateTimePicker,
  StaticDateTimePicker,
  TimePicker,
  StaticTimePicker,
} from "@mui/lab";
import {
  TextField,
  //} from "@material-ui/core";
} from "@mui/material";

export default function AMDatePicker({
  name,
  error,
  control,
  onChange,
  value,
  ...rest
}) {
  const { i18n } = useTranslation();
  control = {};
  const getMessage = (x) => {
    return x;
  };
  const [invalidDateError, setInvalidDateError] = useState("");
  const { helperText, disabled, inputVariant } = rest;
  const label = control.caption ? control.caption : name;

  // RTL languages
  const rtlLanguages = ["ar", "he", "fa", "ur"];
  const isRTL = rtlLanguages.includes(i18n.language);

  const handleDateChange = (date) => {
    if (date === null) {
      onChange({ target: { name, value: null } });
      setInvalidDateError("");
      onChange({ target: { name, value: null } });
      return;
    }

    let d = date.toString();
    if (date !== null && date.toString() !== "Invalid Date") {
      d =
        date.getFullYear().toString() +
        "/" +
        (date.getMonth() + 1).toString() +
        "/" +
        date.getDate().toString();
      setInvalidDateError("");
    } else {
      setInvalidDateError(getMessage("invalid_date"));
    }

    onChange({ target: { name, value: d.toString() } });
  };
  return (
    <DatePicker
      //label="Basic example"
      onChange={handleDateChange}
      // onChange={(newValue) => {
      //   setValue(newValue);
      // }}

      autoOk={true}
      variant="inline"
      inputVariant={inputVariant || "outlined"}
      inputFormat="dd/MM/yyyy"
      mask="__/__/____"
      disabled={disabled}
      name={name}
      helperText={error || invalidDateError || helperText}
      error={error || invalidDateError ? true : false}
      value={value}
      {...rest}
      KeyboardButtonProps={{
        "aria-label": "change date",
      }}
      //size="small"
      renderInput={(params) => (
        <TextField
          size="small"
          margin="dense"
          variant="outlined"
          {...params}
          fullWidth={true}
          helperText={error || invalidDateError || helperText}
          error={error || invalidDateError ? true : false}
          inputProps={{
            ...params.inputProps,
            style: { textAlign: isRTL ? "right" : "left" },
          }}
          sx={{
            "& .MuiInputLabel-root": {
              fontWeight: "bold",
              // color: theme.palette.secondary.main,
            },
          }}
        />
      )}
    />
  );
  //   return (
  //     <MuiPickersUtilsProvider utils={DateFnsUtils}>
  //       <KeyboardDatePicker
  //         // disableToolbar
  //         autoOk={true}
  //         margin="dense"
  //         onChange={handleDateChange}
  //         variant="inline"
  //         inputVariant={inputVariant || "outlined"}
  //         format="dd/MM/yyyy"
  //         disabled={disabled}
  //         name={name}
  //         label={label}
  //         helperText={error || invalidDateError || helperText}
  //         error={error || invalidDateError ? true : false}
  //         //  id="date-picker-inline"
  //         //label="Date picker inline"
  //         //value={selectedDate}
  //         {...rest}
  //         KeyboardButtonProps={{
  //           "aria-label": "change date",
  //         }}
  //       />
  //     </MuiPickersUtilsProvider>
  //   );
}
